import { render, staticRenderFns } from "./RigthComponentLigth.vue?vue&type=template&id=7c06ee1a&scoped=true&"
import script from "./RigthComponentLigth.vue?vue&type=script&lang=js&"
export * from "./RigthComponentLigth.vue?vue&type=script&lang=js&"
import style0 from "./RigthComponentLigth.vue?vue&type=style&index=0&id=7c06ee1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c06ee1a",
  null
  
)

export default component.exports